<p role="timer"
   *transloco="let t"
   [innerHtml]="t('COMMON.REDIRECT_INFO', {seconds: redirectDelay$ | async, targetUrl: targetUrl()})">
</p>
